import React from 'react';
import { ShoppingCart } from 'lucide-react';
import { useCart } from '../../context/CartContext';
import { useAuth } from '../../context/AuthContext';
import AccountMenu from './AccountMenu';

const AuthBar: React.FC = () => {
  const { itemCount, openCart } = useCart();
  const { user, loading } = useAuth();
  return (
    <div style={{
      display: 'flex', justifyContent: 'flex-end', alignItems: 'center',
      gap: '16px', padding: '10px 20px', backgroundColor: '#1e293b',
      color: '#fff', fontSize: '0.9rem',
    }}>
      <button
        onClick={openCart}
        aria-label={`Cart with ${itemCount} items`}
        style={{ color: '#fff', background: 'none', border: 'none', cursor: 'pointer', padding: 0, display: 'inline-flex', alignItems: 'center', gap: '4px', position: 'relative' }}
      >
        <ShoppingCart size={18} />
        {itemCount > 0 && (
          <span style={{
            position: 'absolute', top: '-8px', right: '-10px',
            backgroundColor: '#e74c3c', color: '#fff', fontSize: '10px', fontWeight: 'bold',
            borderRadius: '50%', width: '16px', height: '16px',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
          }}>
            {itemCount > 99 ? '99+' : itemCount}
          </span>
        )}
      </button>
      {!loading && (user ? <AccountMenu /> : <a href="/auth/login" style={{ color: '#fff', textDecoration: 'none' }}>Login</a>)}
    </div>
  );
};

export default AuthBar;
